// extracted by mini-css-extract-plugin
export default {"Logo":"QoSBm","centeredBottomLogo":"dL6k1"};